'use strict';

require('babel-core/polyfill');
require('console-shim');
require('promise.prototype.finally');
require('./utils/polyfills/ScrollIntoViewIfNeededPolyfill');
require('./utils/polyfills/window.devicePixelRatio.js');
require('./utils/polyfills/viewportUnits.js');

// looks weird, I know. core-js Promise is not always the same as window.Promise,
// which is polyfilled with `promise.prototype.finally`

Promise.prototype.finally = window.Promise.prototype.finally;

require('index.less');

import React from 'react';
import router from './router';
import AnimationFrame from 'animation-frame';
import Analytics from './utils/Analytics';
import AnalyticsEvents from './constants/AnalyticsEvents';
import AppDispatcher from './AppDispatcher';
import RAFBatchingStrategy from './utils/RAFBatchingStrategy';
import ReactUpdates from 'react/lib/ReactUpdates';
import injectTapEventPlugin from 'react-tap-event-plugin';
import config from 'config';
import UserStore from './stores/UserStore';
import CrashReporter from 'CrashReporter';
import NotificationMessages from './constants/NotificationMessages';
import RouterActionCreators from './actions/RouterActionCreators';
import NotificationActionCreators from './actions/NotificationActionCreators';
import { isIE10 } from './utils/Browser';

import AuthPopup from './AuthPopup';

window.addEventListener('DOMContentLoaded', function () {
  // It is essential to render to a div we control,
  // because Google Font Loader will put junk in <body>
  const rootEl = document.getElementById('root');

  if (config.isAuthPopup) {
    React.render(<AuthPopup authType={config.authType} />, rootEl);
  } else {
    router.run((Handler, state) => {
      RouterActionCreators.changeRoute(state);
      React.render(<Handler {...state} />, rootEl);
    });
  }
});

CrashReporter.setup();
AnimationFrame.shim();
ReactUpdates.injection.injectBatchingStrategy(RAFBatchingStrategy);
injectTapEventPlugin();

config.actions.forEach(function (action) {
  AppDispatcher.handlePreloadedAction(action);
});

if (UserStore.isAuthenticated()) {
  CrashReporter.associateWithUser(UserStore.getMe());
}

Analytics.start();

if (config.trackSignUp) {
  Analytics.trackGAEvent(AnalyticsEvents.STAMPSY_SIGNUP);
  Analytics.trackEvent(AnalyticsEvents.STAMPSY_SIGNUP);
}

if (isIE10()) {
  NotificationActionCreators.showNotification(NotificationMessages.UNSUPPORTED_BROWSER);
}



/** WEBPACK FOOTER **
 ** ./index.js
 **/